<script setup>
import axios from 'axios'
import { Message } from '@arco-design/web-vue';

const loading = ref(false)
// 搜索
const searchKeyword = ref('')
const handleSearch = async () => {
    loading.value = true

    const res = await axios.get(`/console/v1/help?keywords=${searchKeyword.value}`)
    // 处理搜索结果，为匹配的 help 项添加标记
    const searchResults = res.data.data.list.map(item => {
        // 为所有 help 项添加 isMatched 标记
        const markedHelps = item.helps.map(help => ({
            ...help,
            isMatched: help.search || false // 匹配的标记为 true
        }))

        return {
            ...item,
            helps: markedHelps
        }
    })

    file.value = searchResults

    Message.success(res.data.msg)



    // 在搜索结果渲染后，跳转到第一个匹配的项
    nextTick(() => {
        jumpToFirstMatchedItem()
    })
}

// 或者跳转到第一个匹配的文档项
const jumpToFirstMatchedItem = () => {
    // 方法1：通过 DOM 查询
    const firstMatch = document.querySelector('.matched')
    if (firstMatch) {
        firstMatch.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        })

        // 添加点击效果
        firstMatch.classList.add('click-highlight')
        setTimeout(() => {
            firstMatch.classList.remove('click-highlight')
        }, 1000)
    }

    loading.value = false
}


// 文档列表数据
const file = ref([])
const documentRequest = async () => {
    const res = await axios.get('/console/v1/help')
    file.value = res.data.data.list
}
documentRequest()

</script>

<template>


    <!-- banner图 -->
    <div class="Heziyun-banners">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('doc.bannerTitle') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">
                    {{ $t('doc.bannerDesc') }}
                </p>
                <div class="Heziyun-search" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <svg t="1766354120215" class="icon" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="18887" width="128" height="128">
                        <path
                            d="M802.133333 770.438095l-121.904762-121.904762c42.666667-47.542857 68.266667-109.714286 68.266667-177.980952 0-147.504762-120.685714-268.190476-268.190476-268.190476s-268.190476 120.685714-268.190476 268.190476 120.685714 268.190476 268.190476 268.190476c57.295238 0 110.933333-18.285714 154.819048-48.761905l124.342857 124.342858 42.666666-43.885715zM273.066667 470.552381c0-114.590476 92.647619-207.238095 207.238095-207.238095s207.238095 92.647619 207.238095 207.238095-92.647619 207.238095-207.238095 207.238095-207.238095-92.647619-207.238095-207.238095z"
                            fill="#8a8a8a" p-id="18888"></path>
                    </svg>
                    <input type="text" :placeholder="$t('doc.searchPlaceholder')" v-model="searchKeyword"
                        @keyup.enter="handleSearch" />
                    <a-button type="primary" :loading="loading" @click="handleSearch">{{
                        $t('doc.searchButton') }}</a-button>
                </div>
            </div>
        </div>
    </div>

    <!-- 文档列表 -->
    <div class="Heziyun-file Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('doc.contentTitle')
                }}</span>
                <p></p>
            </div>
            <div class="Heziyun-file-list">
                <div class="Heziyun-item" v-for="(item, index) in file" :key="item.id" v-show="item.helps.length !== 0"
                    v-intersect="{ class: 'bottom-top', delay: index * 20 }">
                    <div class="Heziyun-item-title">
                        {{ item.name }}
                    </div>
                    <div class="Heziyun-grit">
                        <a-tooltip :content="items.title" v-for="items in item.helps" :key="items.id">
                            <a :href="`/help/${items.id}.html`" :class="{ 'matched': items.isMatched }">
                                <span>{{ items.title }}</span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="icon_1FkWL">
                                    <path d="M2 9h12l-3.429-4" stroke="#2C5EFF" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </svg>
                            </a>
                        </a-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style>
@import "@/static/css/import";
@import "@/static/font/font.css";

body {
    background-color: #f5f7fc;
}
</style>

<style lang="less" scoped>
:deep(.arco-btn-size-medium:not(.arco-btn-only-icon) .arco-btn-icon) {
    font-size: 15px;

}

// banner图
.Heziyun-banners {
    background: url('@/static/img/document/banner.webp') no-repeat right;
    background-size: cover;
    position: relative;
    height: 25rem;

    .Heziyun-defaultWidth {
        position: relative;
        z-index: 2;
        height: 100%;


        .Heziyun-banner-title {

            span {
                color: #333;
            }

            p {
                color: #333;
            }

            .Heziyun-search {
                position: relative;

                svg {
                    position: absolute;
                    width: 30px;
                    height: 30px;
                    top: 50%;
                    left: 10px;
                    transform: translateY(-50%);
                }

                input {
                    width: 600px;
                    height: 50px;
                    border-radius: 2px;
                    outline: none;
                    padding-left: 40px;
                    padding-right: 100px;
                    background-image: linear-gradient(0deg, #fff, #f3f5f8);
                    border: 2px solid #fff;
                    box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);

                    &:focus {
                        background-image: linear-gradient(0deg, #fff, #fff);
                    }
                }

                button {
                    position: absolute;
                    right: 1px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 100px;
                    height: 95%;
                    background-color: #0056ff;
                    color: #fff;
                    cursor: pointer;
                    border-radius: 2px;
                    font-size: 16px;

                    &:hover {
                        background-color: #4c82ff;
                    }
                }
            }
        }
    }

}

// 文档列表
.Heziyun-file {
    .Heziyun-defaultWidth {
        padding: 3.5rem 0;

        .Heziyun-file-list {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 2rem;

            .Heziyun-item {
                color: #25345c;
                border: 1px solid #e1e6f4;

                .Heziyun-item-title {
                    font-size: 17px;
                    padding: 20px;
                    background: url('@/static/img/document/back2.webp') no-repeat center;
                    background-size: cover;
                    border-bottom: 1px solid #e1e6f4;
                }

                .Heziyun-grit {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);

                    a {
                        padding: 12px 15px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        font-size: 15px;
                        color: #7786ab;
                        gap: 0.5rem;
                        min-width: 0; // 关键：允许flex子元素收缩
                        border: 1px solid transparent;

                        span {
                            display: block;
                            // 一处显示省略号
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            flex: 1; // 关键：占用可用空间
                            min-width: 0; // 关键：允许收缩到0
                        }

                        &:hover {
                            background-color: #fff;
                            box-shadow: 0 .5rem 1rem rgba(130, 158, 219, .16);
                            color: #0056ff;

                            svg {
                                opacity: 1;
                            }
                        }

                        svg {
                            width: 16px;
                            height: 16px;
                            opacity: 0;
                            flex-shrink: 0; // 防止图标被压缩
                        }
                    }

                    .matched {
                        border: 1px solid #0056ff;
                        animation: pulse 2s infinite;
                    }

                    @keyframes pulse {
                        0% {
                            box-shadow: 0 0 0 0 rgba(0, 86, 255, 0.4);
                        }

                        70% {
                            box-shadow: 0 0 0 10px rgba(0, 86, 255, 0);
                        }

                        100% {
                            box-shadow: 0 0 0 0 rgba(0, 86, 255, 0);
                        }
                    }
                }
            }


        }
    }
}

@media (max-width: 768px) {

    // banner图
    .Heziyun-banners {
        height: 80vw;

        .Heziyun-defaultWidth {

            .Heziyun-banner-title {
                align-items: center;

                .Heziyun-search {
                    position: relative;
                    width: 100%;

                    svg {
                        position: absolute;
                        width: 7vw;
                        height: 7vw;
                        top: 50%;
                        left: 10px;
                        transform: translateY(-50%);
                    }

                    input {
                        width: 100%;
                        height: 10vw;
                        padding-left: 10vw;
                        padding-right: 17vw;

                        &::placeholder {
                            font-size: 3.5vw;
                        }
                    }

                    button {
                        width: 17vw;
                        font-size: 4vw;
                    }
                }
            }
        }

    }

    // 文档列表
    .Heziyun-file {
        .Heziyun-defaultWidth {
            padding: 5vw;

            .Heziyun-file-list {
                grid-template-columns: repeat(1, 1fr);
                gap: 3vw;

                .Heziyun-item {

                    .Heziyun-item-title {
                        font-size: 5vw;
                        padding: 4vw 6vw;
                    }

                    .Heziyun-grit {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);

                        a {
                            padding: 3vw 4vw;
                            font-size: 4vw;

                            svg {
                                width: 3vw;
                                height: 3vw;
                            }
                        }
                    }
                }


            }
        }
    }
}
</style>